var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpgradeBurstLaser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 252 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #68d7f1;\n      }\n\n      .cls-2 {\n        fill: #57b1c0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "252 15 0 15 30 0 222 6 252 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "252 15 0 15 30 30 222 24 252 15"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeBurstLaser);
export default __webpack_public_path__ + "static/media/upgrade-burst-laser.03853a1938db816c5076901e42574b26.svg";
export { ForwardRef as ReactComponent };